/**
 * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */

export default {
	EmailFrequency: {
		EMAIL_SEND_HOURLY: 0,
		EMAIL_SEND_DAILY: 1,
		EMAIL_SEND_WEEKLY: 2,
		EMAIL_SEND_ASAP: 3,
	},
}
